import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Router } from '@angular/router';
import { ModalPopoverPage } from "../modal-popover/modal-popover.page";
import { AppServiceService } from "../../../../api/app-service.service";
import consts from '../constatnts.json';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'web-header',
  templateUrl: './web-header.page.html',
  styleUrls: ['./web-header.page.scss'],
})

export class WebHeaderComponent implements OnInit {
  POPOVER_TYPES = consts.POPOVER_TYPES;
  logoUrl = environment.BASE_URL + '/images/restaurant-logo/web/';
   
  public lang :any;

  constructor(private modalController: ModalController, public appService: AppServiceService, public router: Router,public translate: TranslateService) { }

  ngOnInit() {
    this.getLang();
  }

  async openModalPopup(popoverType) {
    const modal = await this.modalController.create({
      component: ModalPopoverPage,
      cssClass: 'order-popup',
      componentProps: {
        'type': popoverType.TYPE,
        'title': popoverType.TITLE
      }
    });

    await modal.present();
  }

  async navigateToMenu() {
    if (!this.appService.appObject.selectedDeliveryMethod) {
      this.navigateToBranchMenu(null);
    } else {
      if(!this.appService.appObject.selectedRestaurant) this.appService.showToast(this.lang.try_after_few_seconds);
      this.router.navigate(['menu',this.appService.appObject.selectedRestaurant]);
    }
  }

  /**
   * User will navigate into selected branch's menu page
   * @param branch selected branch to navigate into
   */
  async navigateToBranchMenu(branch) {

    const modal = await this.modalController.create({
      component: ModalPopoverPage,
      cssClass: 'order-popup',
      componentProps: {
        'title': 'key.select_order_type',
        'type': 'delivery-type',
        'selectedBranch': branch
      }
    });

    await modal.present();
    // this.appService.getRestaurantBySlug(branch.slug).then((response) => {
    //   this.router.navigate(['/menu']);
    // });

  }

  isMenuPage(){
    if(window.location.pathname){
      let splited = window.location.pathname.split('/');
      // console.log('splited : ', splited);
      return splited.length >= 2 ? splited[1] === 'menu' : false;
    }
    return false; //window.location.pathname === '/menu';
  }

  /**
   * 
   * get languages
   */
   async getLang(){
    await this.translate.get('key').subscribe(
      value => {
        this.lang = value;
      }
    )
  }
}
